/* eslint-disable eqeqeq */
import React from "react";
import { durationOption } from "../../Context/constants";
import { Errors } from "../../Component/Error";
import Loading from "../../Component/Loading";
import { Avatar, Badge, FormControlLabel, Radio, RadioGroup, } from "@mui/material";
import useServices from "./Hooks/useServices";
import { ServiceImageFilePath } from "../../Context/api";
import { SelectBox } from "../../Component/Inputs";
import DeleteProfile from "../../Component/DeleteProfile";
import { MdOutlineCameraAlt } from "react-icons/md";
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { pattern } from "../../Context/Validation";
const EditServices = () => {
  const {
    UploadImage,
    setImgUrl,
    setLoader,
    CustomButton,
    upadteservicesfun,
    SpecializationListdata,
    imgUrl,
    loader,
    FileRef,
    SmallAvatar,
    GSTList
  } = useServices()
  const navigate = useNavigate()

  return <>
    {loader && <Loading />}
    <div className="common-component-box">
      {/* <header className="body_header" >
        <div className="d-flex justify-content-start align-items-center">
          <h2 className="page_name">Edit Service</h2>
        </div>
      </header> */}
      <header className="body_header" >
        <div className="d-flex justify-content-start align-items-center ">
          <FaArrowLeft className="me-2 cursor" onClick={() => { navigate(-1) }} />
          <h2 className="page_name">Edit Service</h2>
        </div>
      </header>
      <div className="row common-white-bg-box mx-0 shadow position-relative">
        <div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Display Picture</label>
              </div>
              <div className="col-4 d-flex  align-items-start flex-column">
                <Badge
                  style={{ background: "#fff" }}
                  overlap="circular"
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  badgeContent={
                    <SmallAvatar alt="Remy Sharp"  >
                      <MdOutlineCameraAlt onClick={() => FileRef.current.click()} style={{ cursor: "pointer" }} >
                      </MdOutlineCameraAlt>
                      <input type="file" ref={FileRef} className='d-none ' accept="image/*" name="file" onChange={(e) => UploadImage(e, FileRef, "SERVICE", setLoader, setImgUrl)} />
                    </SmallAvatar>
                  }
                >
                  <Avatar  sx={{ width: 80, height: 80 }} src={ServiceImageFilePath + imgUrl} >
                  </Avatar>
                </Badge>
                {imgUrl && <DeleteProfile setImgUrl={setImgUrl} deletedData={{ fileName: imgUrl, type: "SERVICE", id: upadteservicesfun?.values?.serviceId }} isDeleted={true} />}
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Display Picture</label>
                  </div>
                  <div className="col-lg-7 d-grid justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start justify-content-xl-start justify-content-xxl-start">
                    <Badge
                      style={{ background: "#fff" }}
                      overlap="circular"
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      badgeContent={
                        <SmallAvatar alt="Remy Sharp"  >
                          <MdOutlineCameraAlt onClick={() => FileRef.current.click()} style={{ cursor: "pointer" }} >
                          </MdOutlineCameraAlt>
                          <input type="file" ref={FileRef} className='d-none ' accept="image/*" name="file" onChange={(e) => UploadImage(e, FileRef, "SERVICE", setLoader, setImgUrl, imgUrl, upadteservicesfun?.values?.serviceId)} />
                        </SmallAvatar>
                      }
                    >
                      <Avatar sx={{ width: 80, height: 80 }} src={ServiceImageFilePath + imgUrl} >
                      </Avatar>
                    </Badge>
                    {imgUrl && <DeleteProfile setImgUrl={setImgUrl} deletedData={{ fileName: imgUrl, type: "SERVICE", id: upadteservicesfun?.values?.serviceId }} isDeleted={true} />}
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Name<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <input maxLength={20} type="text" className="form-control" name="serviceName" value={upadteservicesfun.values.serviceName}
                  onChange={(e) => upadteservicesfun.setFieldValue("serviceName", e.target.value)}
                />
                <Errors formikfun={upadteservicesfun} name={"serviceName"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Name<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <input maxLength={50} type="text" className="form-control" name="serviceName" value={upadteservicesfun.values.serviceName}
                      onChange={(e) => upadteservicesfun.setFieldValue("serviceName", e.target.value)}
                    />
                    <Errors formikfun={upadteservicesfun} name={"serviceName"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Duration (in minutes)<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <SelectBox
                  placeholder="Select Discount Type"
                  value={upadteservicesfun.values.duration}
                  name="duration"
                  keys="value"
                  label="label"
                  menuValeu="value"
                  handleChange={(e) => upadteservicesfun.setFieldValue("duration", e.target.value)}
                  option={durationOption}
                />
                <Errors formikfun={upadteservicesfun} name={"duration"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Duration (in minutes)<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <SelectBox
                      placeholder="Select Discount Type"
                      value={upadteservicesfun.values.duration}
                      name="duration"
                      keys="value"
                      label="label"
                      menuValeu="value"
                      handleChange={(e) => upadteservicesfun.setFieldValue("duration", e.target.value)}
                      option={durationOption}
                    />
                    <Errors formikfun={upadteservicesfun} name={"duration"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-4 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Specialization<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <select className='form-select' name="specializationId"
                  value={upadteservicesfun?.values?.specializationId}
                  onChange={(e) => upadteservicesfun.setFieldValue("specializationId", e.target.value)} >
                  <option hidden>Select specialization</option>
                  {
                    SpecializationListdata?.map((cur, index) => {
                      return <option key={cur?.specializationId} value={cur?.specializationId}>{cur?.specializationName}</option>
                    })
                  }
                </select>
                <Errors formikfun={upadteservicesfun} name={"specializationId"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Specialization<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <SelectBox
                      placeholder=" Select specialization"
                      value={upadteservicesfun?.values?.specializationId}
                      name="specializationId"
                      keys="specializationId"
                      label="specializationName"
                      menuValeu="specializationId"
                      handleChange={(e) => upadteservicesfun.setFieldValue("specializationId", e.target.value)}
                      option={SpecializationListdata}
                    />
                    <Errors formikfun={upadteservicesfun} name={"specializationId"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Group<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="group"
                    row
                    value={upadteservicesfun.values.group}
                    onChange={(e) => {
                      upadteservicesfun.setFieldValue("group", e.target.value);
                      (e.target.value == "false" && upadteservicesfun.setFieldValue("noOfPatients", 1))
                    }}
                  >
                    <FormControlLabel value={true} control={<Radio />} label="Yes" />
                    <FormControlLabel value={false} control={<Radio />} label="No" />
                  </RadioGroup>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Group<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <div className="d-flex">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="group"
                        row
                        value={upadteservicesfun.values.group}
                        onChange={(e) => {
                          upadteservicesfun.setFieldValue("group", e.target.value);
                          (e.target.value == "false" && upadteservicesfun.setFieldValue("noOfPatients", 1))
                        }}
                      >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                      </RadioGroup>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Number of patients<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <input type="number" disabled={upadteservicesfun.values.group == "true" ? false : true}
                  value={upadteservicesfun.values.noOfPatients}
                  className='form-control' name="noOfPatients"
                  onChange={(e) => upadteservicesfun.setFieldValue("noOfPatients", e.target.value)}
                />
                <Errors formikfun={upadteservicesfun} name={"noOfPatients"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Number of patients<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <input type="number" disabled={upadteservicesfun.values.group == "true" ? false : true}
                      value={upadteservicesfun.values.noOfPatients}
                      className='form-control' name="noOfPatients"
                      onChange={(e) => upadteservicesfun.setFieldValue("noOfPatients", e.target.value)}
                      maxLength={3}
                      onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                    />
                    <Errors formikfun={upadteservicesfun} name={"noOfPatients"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3" style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Price<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-2">
                <input type="number" placeholder="Fixed Price" className="form-control" name="fixedPrice" value={upadteservicesfun.values.fixedPrice}
                  onChange={(e) => upadteservicesfun.setFieldValue("fixedPrice", e.target.value)}
                  maxLength={12}
                  onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                />
                <Errors formikfun={upadteservicesfun} name={"fixedPrice"} />
              </div>
              <div className="col-2">
                <input type="number" className="form-control" name="variablePrice" value={upadteservicesfun.values.variablePrice}
                  onChange={(e) => upadteservicesfun.setFieldValue("variablePrice", e.target.value)}
                  maxLength={12}
                  onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                />
                <Errors formikfun={upadteservicesfun} name={"variablePrice"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Price<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <div className="row">
                      <div className="col-6">
                        <input type="number" placeholder="Fixed Price" className="form-control" name="fixedPrice" value={upadteservicesfun.values.fixedPrice}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (pattern?.DECIMAL_LIMIT?.test(value)) upadteservicesfun.setFieldValue("fixedPrice", value);
                          }}
                          maxLength={12}
                          onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                        />
                        <Errors formikfun={upadteservicesfun} name={"fixedPrice"} />
                      </div>
                      <div className="col-6">
                        <input type="number" className="form-control" name="variablePrice" value={upadteservicesfun.values.variablePrice}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (pattern?.DECIMAL_LIMIT?.test(value)) upadteservicesfun.setFieldValue("variablePrice", value);
                          }}
                          maxLength={12}
                          onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                        />
                        <Errors formikfun={upadteservicesfun} name={"variablePrice"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>

          <div className="col-sm-12  py-3" style={{ borderBottom: "2px solid #ededed" }}>
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">GST(%)</label>
                  </div>
                  <div className="col-lg-7">
                    <SelectBox
                      placeholder="Select Discount Type"
                      value={upadteservicesfun.values.gstId}
                      name="gstId"
                      keys="gstId"
                      label="rate"
                      menuValeu="gstId"
                      handleChange={(e) => upadteservicesfun.setFieldValue("gstId", e.target.value)}
                      option={GSTList}
                    />
                    <Errors formikfun={upadteservicesfun} name={"gstId"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>

          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">HSN Code</label>
                  </div>
                  <div className="col-lg-7">
                    <input
                      type="number"
                      value={upadteservicesfun.values.hsnCode}
                      className='form-control' name="hsnCode"
                      onChange={(e) => upadteservicesfun.setFieldValue("hsnCode", e.target.value)}
                      maxLength={12}
                      onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                    />
                    <Errors formikfun={upadteservicesfun} name={"hsnCode"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
          <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
            {/* <div className="row">
              <div className="col-3">
                <label className="form-label mb-0">Description<span className='Star_Mark'>*</span></label>
              </div>
              <div className="col-4">
                <textarea className="form-control" cols="30" name="description" value={upadteservicesfun.values.description}
                  onChange={(e) => upadteservicesfun.setFieldValue("description", e.target.value)}>
                </textarea>
                <Errors formikfun={upadteservicesfun} name={"description"} />
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-5">
                    <label className="form-label mb-0">Description<span className='Star_Mark'>*</span></label>
                  </div>
                  <div className="col-lg-7">
                    <textarea className="form-control" cols="30" name="description" value={upadteservicesfun.values.description}
                      onChange={(e) => upadteservicesfun.setFieldValue("description", e.target.value)}>
                    </textarea>
                    <Errors formikfun={upadteservicesfun} name={"description"} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 d-grid justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end justify-content-xxl-end my-3">
          <div>
            <CustomButton variant="contained" type="button" onClick={upadteservicesfun.handleSubmit} >update</CustomButton>
          </div>
        </div>
      </div>
    </div>

  </>
}

export default EditServices